import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setMetaAttribution } from '../../AppActions';
import { getBrowserMetaAttribution } from '../../../../util/metaTracking.js';

import withRouter from '../../../../components/Router/WithRouter';

// Capture fbclid / gclid / UTM / cookies Pixel (_fbp, _fbc) pour attribution first-party + CAPI.
// Recapture après consent cookies (Pixel vient de poser _fbp) et retry court si GTM est lent.
function MetaAttributionInit({ dispatch, search }) {
    useEffect(() => {
        const capture = () => {
            const payload = getBrowserMetaAttribution(search);
            if(payload) {
                dispatch(setMetaAttribution(payload));
            }
        };

        capture();

        // Pixel GTM souvent posé après accept : retry pour récupérer _fbp
        const retryTimers = [1500, 4000, 8000].map(delay => window.setTimeout(capture, delay));

        const onConsent = event => {
            if(event?.detail?.value === 'accepted') {
                capture();
                window.setTimeout(capture, 1200);
                window.setTimeout(capture, 3500);
            }
        };
        window.addEventListener('mls:cookie-consent', onConsent);

        return () => {
            retryTimers.forEach(timer => window.clearTimeout(timer));
            window.removeEventListener('mls:cookie-consent', onConsent);
        };
    }, []); // capture initiale + retries ; search lu depuis la closure du montage

    return null;
}

MetaAttributionInit.propTypes = {
    dispatch: PropTypes.func.isRequired,
    search: PropTypes.object.isRequired,
};

export default connect()(withRouter(MetaAttributionInit, ['search']));
